module.exports = __webpack_public_path__ + "static/img/gzh_detail.ad088a83.png";